import { useIntl } from 'react-intl'

export const useConditionalText = (
  condition: boolean,
  translationId: string,
  alternativeTranslationId: string
) => {
  const { formatMessage } = useIntl()

  return condition
    ? formatMessage({
        id: translationId
      })
    : formatMessage({
        id: alternativeTranslationId
      })
}
